import { Duration, proto3, Timestamp } from '@bufbuild/protobuf';
import { generateTypes } from '@evmos/eip712';
import { createAnyMessage } from '@evmos/proto/dist/messages/common';
import { TxContext, TxPayload, createTransactionPayload } from '@evmos/transactions';
import { EIP712TypedData } from '@evmos/transactions/dist/messages/base';
import { MsgRevokeAllowance } from '@buf/cosmos_cosmos-sdk.bufbuild_es/cosmos/feegrant/v1beta1/tx_pb';

const CREATE_MSG_REVOKE_ALLOWANCE_TYPES = {
  MsgValue: [
    { name: 'granter', type: 'string' },
    { name: 'grantee', type: 'string' },
  ],
};

export interface MsgRevokeAllowanceParams {
  granteeAddress: string;
}

export const createTxMsgRevokeAllowance = (
  context: TxContext,
  params: MsgRevokeAllowanceParams | MsgRevokeAllowanceParams[],
): TxPayload => {
  const typedData = createEIP712MsgRevokeAllowance(context, params);
  const cosmosMsg = createCosmosMsgRevokeAllowance(context, params);
  return createTransactionPayload(context, typedData, cosmosMsg);
};

const createEIP712MsgRevokeAllowance = (
  context: TxContext,
  params: MsgRevokeAllowanceParams | MsgRevokeAllowanceParams[],
): EIP712TypedData => {
  const types = generateTypes(CREATE_MSG_REVOKE_ALLOWANCE_TYPES);
  const messages = (Array.isArray(params) ? params : [ params ])
    .map((params) => createMsgRevokeAllowance(context, params));
  return { types, message: messages.length === 1 ? messages[0] : messages };
};

const createCosmosMsgRevokeAllowance = (
  context: TxContext,
  params: MsgRevokeAllowanceParams | MsgRevokeAllowanceParams[],
): any => {
  return (Array.isArray(params) ? params : [ params ]).map((params) => {
    const message = new MsgRevokeAllowance({
      granter: context.sender.accountAddress,
      grantee: params.granteeAddress,
    });
    return { message, path: MsgRevokeAllowance.typeName };
  });
};

function createMsgRevokeAllowance(context: TxContext, params: MsgRevokeAllowanceParams): object {
  return {
    type: 'cosmos-sdk/MsgRevokeAllowance',
    value: { granter: context.sender.accountAddress, grantee: params.granteeAddress },
  };
}
